import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export enum GetArticleByIdCacheKey {
  GetArticleById = 'GetArticleById',
}

export const useGetArticleByIdQuery = (id: number, enabled: boolean) => {
  const { getArticleById } = useServicesContext();
  return useQuery({
    queryKey: [GetArticleByIdCacheKey.GetArticleById, id],
    queryFn: () => getArticleById({ id }),
    enabled,
  });
};
